{
  "tabs": {
    "chat": "Csevegés",
    "reminders": "Emlékeztetők",
    "calendar": "Naptár",
    "settings": "Beállítások"
  },
  "common": {
    "cancel": "Mégse",
    "save": "Mentés",
    "confirm": "Megerősít",
    "delete": "Törlés",
    "back": "Vissza",
    "close": "Bezár",
    "edit": "Szerkeszt",
    "search": "Keresés",
    "all": "Mind",
    "loading": "Betöltés...",
    "error": "Hiba történt",
    "notFound": "Nem található",
    "tryAgain": "Próbáld újra",
    "retry": "Újra",
    "undo": "Visszavonás",
    "pullToRefresh": "Húzd lefelé a frissítéshez",
    "justNow": "épp most"
  },
  "auth": {
    "welcome": "Üdv a FishMemory-ben",
    "tagline": "WhatsApp emlékeztető asszisztensed, most a zsebedben.",
    "subtitle": "WhatsApp emlékeztető asszisztensed, most a zsebedben.",
    "phoneLabel": "WhatsApp számod",
    "phoneHint": "Ellenőrző kódot küldünk WhatsApp-on",
    "invalidPhone": "Adj meg érvényes telefonszámot",
    "continue": "Folytatás",
    "enterPhone": "Add meg WhatsApp számod",
    "phonePlaceholder": "Telefonszám",
    "sendCode": "Kód küldése",
    "verifyTitle": "Szám ellenőrzése",
    "otpSentTo": "6 jegyű kódot küldtünk ide: {{phone}} WhatsApp-on",
    "enterFullCode": "Add meg mind a 6 számjegyet",
    "invalidOtp": "Érvénytelen kód. Próbáld újra.",
    "otpFailed": "Nem sikerült elküldeni a kódot. Próbáld újra.",
    "otpResent": "Kód újraküldve",
    "resendIn": "Újraküldés {{seconds}} mp múlva",
    "resendCode": "Kód újraküldése",
    "enterOtp": "Add meg a WhatsApp-on kapott kódot",
    "verify": "Ellenőrzés",
    "resend": "Kód újraküldése",
    "wrongNumber": "Rossz szám?",
    "backToPhone": "Vissza a számhoz",
    "editPhone": "Szám szerkesztése",
    "error": "Hiba",
    "setupTitle": "Állítsuk be",
    "setupSubtitle": "Később a Beállításokban módosíthatod",
    "namePlaceholder": "Neved",
    "letsGo": "Befejezés",
    "skipForNow": "Most kihagyom"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Írj üzenetet...",
    "inputPlaceholder": "Írj üzenetet...",
    "typing": "FishMemory gépel...",
    "online": "Online",
    "connecting": "Kapcsolódás...",
    "reconnecting": "Újrakapcsolódás...",
    "offline": "Offline",
    "empty": "Kezdj beszélgetést",
    "emptyHint": "Hozz létre emlékeztetőket, nézd meg a naptárad, vagy kérj segítséget.",
    "emptyAction": "Minta emlékeztető küldése",
    "actions": "Csevegés műveletek",
    "keep": "Üzenetek megtartása",
    "clearTitle": "Csevegés törlése",
    "clearConfirm": "Törlöd az összes üzenetet ezen az eszközön? Ez nem visszavonható.",
    "clear": "Csevegés törlése",
    "optionSelected": "Kiválasztva: {{label}}",
    "sendingSelection": "Küldés...",
    "connectionLost": "Újrakapcsolódás..."
  },
  "reminders": {
    "title": "Emlékeztetőim",
    "active": "Aktív",
    "today": "Ma",
    "thisWeek": "Ezen a héten",
    "history": "Előzmények",
    "items": "elemek",
    "emptyTitle": "Nincsenek emlékeztetők",
    "emptySubtitle": "Hozz létre egyet a csevegésből, itt fog megjelenni.",
    "emptyAction": "Nyisd meg a csevegést",
    "filterActive": "Aktív",
    "filterToday": "Ma",
    "filterWeek": "Ezen a héten",
    "filterHistory": "Előzmények",
    "emptyState": "Nincsenek emlékeztetők. Kezdj el csevegni!",
    "swipeDone": "Kész",
    "swipeSnooze": "Szundi",
    "swipeDelete": "Törlés",
    "search": "Emlékeztetők keresése...",
    "upcoming": "Közelgő",
    "completed": "Befejezett",
    "overdue": "Lejárt",
    "tomorrow": "Holnap",
    "synced": "Szinkronizálva: {{value}}",
    "swipeHint": "Húzz egy emlékeztetőt a további műveletekhez",
    "noResults": "Nincs találat a keresésre",
    "noResultsHint": "Próbálj más kulcsszót vagy töröld a keresést",
    "deleteAllFailed": "Nem sikerült törölni az összes emlékeztetőt"
  },
  "calendar": {
    "title": "Naptár",
    "today": "Ma",
    "tomorrow": "Holnap",
    "completed": "kész",
    "noEvents": "Nincs ütemezve",
    "noEventsSubtitle": "Válassz egy dátumot az emlékeztetők és események megtekintéséhez.",
    "googleEvent": "Google Naptár",
    "legendActive": "Aktív",
    "legendRecurring": "Ismétlődő",
    "legendDone": "Kész",
    "legendGoogle": "Google",
    "previousMonth": "Előző hónap",
    "nextMonth": "Következő hónap",
    "previousYear": "Előző év",
    "nextYear": "Következő év",
    "goToToday": "Ugrás ma",
    "all": "Mind",
    "active": "Aktív",
    "done": "Kész",
    "paused": "Szüneteltetve"
  },
  "settings": {
    "title": "Beállítások",
    "profile": "Profil",
    "name": "Megjelenítendő név",
    "enterName": "Add meg a neved",
    "language": "Nyelv",
    "uiLanguage": "App nyelve",
    "uiLanguageHelp": "Csak ezen az eszközön változtatja az app felületét, naptár feliratokat és elrendezést.",
    "serverLanguage": "Csevegés nyelve",
    "serverLanguageHelp": "Megváltoztatja a szerver válaszainak és emlékeztető üzenetek nyelvét a fiókodhoz.",
    "timezone": "Időzóna",
    "currentTimezone": "Jelenlegi időzóna",
    "timezoneHelp": "Minden emlékeztető időpontja ebben az időzónában jelenik meg.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Időzóna mentése",
    "timezoneSaved": "Időzóna frissítve",
    "detect": "Észlel",
    "detectFailed": "Nem sikerült észlelni az időzónát",
    "autoDetect": "GPS alapú automatikus észlelés",
    "notifications": "Értesítések",
    "notificationsHelp": "Az ismétlődő emlékeztetők szabályozzák az ismétlődő figyelmeztetéseket. Az eszköz értesítési engedélyeit a telefon beállításaiban kezelheted.",
    "pushEnabled": "Push értesítések",
    "autoDoneOnFire": "Automatikus készre jelölés",
    "autoDoneOnFireDesc": "Ha ki van kapcsolva, az emlékeztetők aktívak maradnak, amíg kézzel nem jelölöd késznek.",
    "googleCalendar": "Google Naptár",
    "google": "Google Naptár",
    "googleConnected": "Csatlakoztatva",
    "googleDisconnected": "Nincs csatlakoztatva",
    "googleConnectedHelp": "Új emlékeztetők automatikusan szinkronizálhatók a naptárral.",
    "googleDisconnectedHelp": "Csatlakoztasd a Google Naptárt az emlékeztetők és események összehangolásához.",
    "googleConnectFailed": "Nem sikerült csatlakoztatni a Google Naptárt",
    "connected": "Csatlakoztatva",
    "disconnected": "Nincs csatlakoztatva",
    "connect": "Csatlakozás",
    "disconnect": "Lecsatlakozás",
    "autoSync": "Új emlékeztetők automatikus szinkronizálása",
    "autosync": "Új emlékeztetők automatikus szinkronizálása",
    "subscription": "Előfizetés",
    "trialUsed": "Próba: {{used}}/{{total}} felhasználva",
    "trialStatus": "Próba elérhető",
    "activeStatus": "Aktív előfizetés",
    "expiredStatus": "Előfizetés lejárt",
    "unsubscribedStatus": "Nincs előfizetés",
    "about": "Névjegy",
    "version": "Verzió",
    "logout": "Kijelentkezés",
    "logoutTitle": "Kijelentkezés",
    "logoutConfirm": "Biztosan ki akarsz jelentkezni?",
    "noName": "Nincs megadva név",
    "serverConnection": "Szerverkapcsolat",
    "serverUrl": "Szerver URL",
    "serverEdit": "Szerkeszt",
    "saveReconnect": "Mentés és újracsatlakozás",
    "resetDefault": "Alapértelmezett visszaállítása",
    "invalidServerUrlTitle": "Érvénytelen szerver URL",
    "invalidServerUrlMessage": "Adj meg érvényes http vagy https szerver URL-t, pl. https://example.com",
    "uiLanguageChangeFailed": "Nem sikerült megváltoztatni az app nyelvét. Próbáld újra.",
    "serverLanguageChangeFailed": "Nem sikerült megváltoztatni a csevegés nyelvét. Próbáld újra.",
    "timezoneChangeFailed": "Nem sikerült megváltoztatni az időzónát. Próbáld újra.",
    "autoSyncChangeFailed": "Nem sikerült frissíteni az automatikus szinkronizálást. Próbáld újra.",
    "nameChangeFailed": "Nem sikerült frissíteni a megjelenítendő nevet. Próbáld újra.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Emlékeztető részletei",
    "editTime": "Idő szerkesztése",
    "rename": "Átnevez",
    "snooze": "Szundi",
    "snooze15": "15 perc szundi",
    "pause": "Szüneteltet",
    "pauseReminder": "Emlékeztető szüneteltetése",
    "resume": "Folytat",
    "resumeReminder": "Emlékeztető folytatása",
    "skip": "Kihagyja a következőt",
    "skipOccurrence": "Ezt az alkalmat kihagyja",
    "syncGoogle": "Szinkron Google-hoz",
    "delete": "Törlés",
    "deleteTitle": "Emlékeztető törlése",
    "deleteConfirm": "Ez az emlékeztető véglegesen törlődik.",
    "deleteRecurringTitle": "Ismétlődő emlékeztető törlése",
    "deleteRecurringMessage": "Kihagyod ezt az alkalmat, vagy törlöd az egész sorozatot?",
    "deleteThisOccurrence": "Ezt az alkalmat kihagyom",
    "deleteEntireSeries": "Az egész sorozat törlése",
    "done": "Kész",
    "markDone": "Késznek jelöl",
    "undo": "Visszaállít",
    "undoPrompt": "Szükséged van rá újra? Állítsd vissza most.",
    "recurring": "Ismétlődő",
    "nextRun": "Következő futás",
    "oneTime": "Egyszeri",
    "pending": "Függőben",
    "sent": "Elküldve",
    "paused": "Szüneteltetve",
    "active": "Aktív",
    "snoozed": "Szundiztatva",
    "localTime": "Helyi idő szerint jelenik meg",
    "recurrence": "Ismétlődés",
    "created": "Létrehozva",
    "tags": "Címkék",
    "fireCount": "Előfordulások száma",
    "actions": "Műveletek",
    "none": "Nincs",
    "snoozeFailed": "Nem sikerült szundiztatni az emlékeztetőt",
    "pauseFailed": "Nem sikerült szüneteltetni az emlékeztetőt",
    "resumeFailed": "Nem sikerült folytatni az emlékeztetőt",
    "skipFailed": "Nem sikerült kihagyni az emlékeztetőt",
    "doneFailed": "Nem sikerült késznek jelölni az emlékeztetőt",
    "undoFailed": "Nem sikerült visszaállítani az emlékeztető állapotát",
    "deleteFailed": "Nem sikerült törölni az emlékeztetőt",
    "rescheduleTitle": "Átütemezed?",
    "rescheduleMsg": "Ez az emlékeztető lejárt. Átütemezed?",
    "reschedule15": "15 perc múlva",
    "reschedule60": "1 óra múlva",
    "keepOverdue": "Így hagyom"
  },
  "onboarding": {
    "slide1Title": "Üdv a FishMemory-ben",
    "slide1Sub": "Személyes emlékeztető asszisztensed — WhatsApp-al működik, a zsebedre szabva.",
    "slide2Title": "Csak csevegj természetesen",
    "slide2Sub": "Írj emlékeztetőket úgy, ahogy gondolod: „Emlékeztess, hogy holnap 3-kor felhívjam anyut” — mi intézzük a többit.",
    "slide3Title": "Sosem maradsz le semmiről",
    "slide3Sub": "Időben értesítünk, címkékkel rendszerezel, és minden fontos dolgot kézben tartasz.",
    "getStarted": "Kezdés",
    "next": "Következő",
    "firstReminderTitle": "Hozd létre az első emlékeztetőd!",
    "firstReminderHint": "Próbáld beírni például:",
    "firstReminderExample": "Emlékeztess, hogy igyak vizet holnap 9-kor",
    "gotIt": "Értem!",
    "notifRationaleTitle": "Maradj időben",
    "notifRationaleBody": "A FishMemory értesítésekre van szüksége, hogy időben emlékeztessen. Csak a saját emlékeztetőidhez kapsz figyelmeztetést.",
    "notifRationaleAllow": "Értesítések engedélyezése",
    "notifRationaleLater": "Majd később",
    "swipeHint": "Húzz jobbra a gyors műveletekhez →",
    "calendarDragHint": "Húzd az átméretezéshez ↕"
  }
}
